import {checkNull} from '@/helpers'

export default {
	name: 'user-notif',
    props: {
        hasClose: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            cdn_url: window.APP_CONFIG.CDN_URL,
            notif_sound: true,
            is_loaded: false
        }
    },
    methods: {
        toggleNotifSound() {
            this.notif_sound = !this.notif_sound
        },
        toggleNotifListener() {
            this.is_loaded = true
        },
        contentLimit(text) {
            return (text.length > 50) ? text.substring(0, 48)+'...' : text
        },
        notifUrl(item, is_label) {
            if(is_label) {
                if(item.type == 'message') return 'See message'
                return 'See profile'
            } else {
                if(['favorite', 'visit'].indexOf(item.type) !== -1) return {name: 'user-other-profile', params: { name: item.nick_name }}
                return {name: 'user-messages-chat', params: { name: item.nick_name }}
            }
        }
    },
    computed: {
        position() {
            return this.$root.$children[0].width > 1199 ? 'bottom right' : 'top center'
        }
    },
	mounted() {

	}
}